import { useEffect, useRef } from 'react';
const creteUseTimer = (clear, runTimer) => (callback, delay) => {
    const timerRef = useRef(undefined);
    useEffect(() => {
        const stop = () => clear(timerRef.current);
        stop();
        timerRef.current = runTimer(callback, delay);
        return stop;
    }, [delay]);
};
export const useInterval = creteUseTimer(clearInterval, setInterval);
export const useTimeout = creteUseTimer(clearTimeout, setTimeout);
